import React from "react";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import WhyChoose from "./components/WhyChoose";
import Resources from "./components/Resources";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./styles.css";

const App: React.FC = () => (
    <div className="page">
        <Navigation />
        <Hero />
        <About />
        <Services />
        <WhyChoose />
        <Resources />
        <Partners />
        <Contact />
        <Footer />
    </div>
);

export default App;
